import MainCard from 'ui-component/cards/MainCard';
import { Button, Grid, Box, TextField, MenuItem, FormControl, Autocomplete } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { useEffect, useState } from 'react';
import { useApi } from 'Service/axios';
import { TableBox } from './style';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';

const Kardex = () => {
    // ============================= INSTÂNCIAS =============================
    const api = useApi();
    // ============================= STATES =============================
    const [itens, setItens] = useState([]);
    const [data, setData] = useState([]);
    const [unmutableData, setUnmatableData] = useState([]);
    const [selectedItem, setSelectedItem] = useState({ id: '' });
    const [selectedDate, setSelectedDate] = useState({ firstDate: '', lastDate: '' });
    const [saldoGeral, setSaldoGeral] = useState(0);
    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.5 },
        { field: 'tipo', headerName: 'Tipo', flex: 1 },
        { field: 'dataMovimento', headerName: 'Data', flex: 1, valueGetter: (params) => formatarDataParaString(params.row.dataMovimento) },
        { field: 'documento', headerName: 'Documento', flex: 1 },
        { field: 'almoxarifado', headerName: 'Almo.', flex: 1 },
        { field: 'localizacao', headerName: 'Loc.', flex: 1 },
        { field: 'entrada', headerName: 'Qtd Entrada', flex: 1 },
        { field: 'saida', headerName: 'Qtd Saída', flex: 1 },
        { field: 'usuario', headerName: 'Usuário', flex: 1 }
    ];

    // ============================= FUNÇÕES =============================

    const formatarDataParaString = (dateValue) => {
        let data = new Date(dateValue);
        const dia = (data.getDate() + 1).toString().padStart(2, '0');
        const mes = (data.getMonth() + 1).toString().padStart(2, '0');
        const ano = data.getFullYear().toString();

        return `${dia}/${mes}/${ano}`;
    };

    const handleSelectionModelChange = (newSelection) => {
        setSelectedItems(newSelection);
    };

    const handleSelectItem = (newValue) => {
        setSelectedItem(newValue || '');
    };

    const handleChangeFirstDate = (value) => {
        setSelectedDate({ ...selectedDate, firstDate: value });
    };

    const handleChangeLastDate = (value) => {
        setSelectedDate({ ...selectedDate, lastDate: value });
    };

    const handleFilterItem = (values, selectedDate) => {
        let firstDate = selectedDate.firstDate;
        let lastDate = selectedDate.lastDate;
        switch (true) {
            case values === '':
                toast.error('Deve ser informado um item');
                break;
            case selectedDate.firstDate === '' && selectedDate.lastDate === '':
                toast.error('Deve ser informado um item com as datas');
                break;
            case values !== '' && selectedDate.firstDate !== '' && !selectedDate.lastDate !== '':
                getDataKardex(values, firstDate, lastDate);
                break;
            default:
                toast.error('Erro ao filtrar, tente novamente');
                break;
        }
    };

    const handleResetFilter = () => {
        setData([]);
        setSelectedItem({ id: '' });
        setSelectedDate({ firstDate: '', lastDate: '' });
    };

    const getItens = async () => {
        try {
            const response = await api.getAllItens();
            setItens(response.data.itens);
        } catch (error) {
            toast.error(`Erro ao buscar itens: ${error.response.data.message}`);
        }
    };

    const [load, setLoad] = useState(false);
    const getDataKardex = async (itemId, startDate, finalDate) => {
        setLoad(true);
        try {
            const response = await api.getKardex(itemId, startDate, finalDate);
            const formatedData = await response.data.kardex.map((item, index) => ({
                ...item,
                id: index + 1
            }));
            setSaldoGeral(response?.data?.saldoGeral);
            setData(formatedData);
            setUnmatableData(formatedData);
            setLoad(false);
            toast.success('Tabela atualizada');
        } catch (error) {
            toast.error(`Erro ao buscas movimentos: ${error.message}`);
        }
    };

    useEffect(() => {
        getItens();
    }, []);

    return (
        <MainCard title="Kardex">
            <Grid container spacing={gridSpacing}>
                <TableBox>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '1em', marginBottom: '1em' }}>
                        <FormControl sx={{ width: '50%' }}>
                            <Autocomplete
                                value={itens.find((el) => el.id === selectedItem) || null}
                                onChange={(event, newValue) => {
                                    handleSelectItem(newValue ? newValue.id : '');
                                }}
                                options={itens}
                                getOptionLabel={(option) => `${option.id} - ${option?.descricao} - ${option?.unidade_medida?.descricao}`}
                                renderInput={(params) => <TextField {...params} label="Item" />}
                            />
                        </FormControl>
                        <FormControl sx={{ width: '20%' }}>
                            <TextField
                                type="date"
                                value={selectedDate.firstDate}
                                onChange={(e) => handleChangeFirstDate(e.target.value)}
                                label="De"
                                InputLabelProps={{ shrink: true }}
                            />
                        </FormControl>
                        <FormControl sx={{ width: '20%' }}>
                            <TextField
                                type="date"
                                value={selectedDate.lastDate}
                                onChange={(e) => handleChangeLastDate(e.target.value)}
                                label="Até"
                                InputLabelProps={{ shrink: true }}
                            />
                        </FormControl>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
                            <Button variant="contained" color="error" onClick={handleResetFilter} sx={{ height: '40px' }}>
                                Limpar
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => handleFilterItem(selectedItem, selectedDate)}
                                sx={{ height: '40px' }}
                                disabled={load}
                            >
                                {load ? 'Carregando...' : 'Pesquisar'}
                            </Button>
                        </Box>
                    </Box>

                    <DataGrid
                        rows={data}
                        columns={columns}
                        hideFooter={true}
                        onSelectionModelChange={() => handleSelectionModelChange(params.id)}
                    />
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '10px', gap: '10px' }}>
                        <p>Saldo Total:</p>
                        <Button variant="outlined" sx={{ color: '#181818', pointerEvents: 'none' }}>
                            {saldoGeral}
                        </Button>
                    </div>
                </TableBox>
            </Grid>
        </MainCard>
    );
};

export default Kardex;
